import Swiper from "swiper";

const initStaticTestimonial = (element) => {
  return new Swiper(element, {
    slidesPerView: 3,
    spaceBetween: 30,
    breakpoints: {
      280: {
        slidesPerView: 1
      },
      1000: {
        slidesPerView: 2
      },
      1100: {
        slidesPerView: 3
      }
    }
  });
};

const staticTestimonials = [...document.querySelectorAll('.kings-static-reviews__grid')];

staticTestimonials.map(element => initStaticTestimonial(element));